module.exports = __webpack_public_path__ + "img/icon20.d0584d7c.svg";